<template>
  <UIInputSelect v-model="criteriaComparison" :size :data :disabled />
  <UIInputText v-if="isFieldVisible" v-model="criteriaValue" :size :disabled />
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount, watch } from 'vue'

import { FilterComparison, TransactionRuleCriteria, InputSize } from '@types'

import { getComparisonData } from '@/components/UI/Filter/components/utils/helpers'

import { UIInputSelect, UIInputText } from '@ui/fields'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<TransactionRuleCriteria['params'][number]>({
  required: true,
})

const size = inject<InputSize>('size')

const criteriaComparison = computed({
  get() {
    return modelValue.value.comparison
  },
  set(comparison) {
    modelValue.value = {
      ...modelValue.value,
      comparison,
    }
  },
})

const criteriaValue = computed({
  get() {
    return modelValue.value.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value,
    }
  },
})

const data = computed(() =>
  getComparisonData().map(value => ({
    value,
    label: value,
  })),
)

const isFieldVisible = computed(
  () =>
    criteriaComparison.value &&
    ![FilterComparison.EMPTY, FilterComparison.NOTEMPTY].includes(
      criteriaComparison.value,
    ),
)

watch(isFieldVisible, value => {
  criteriaValue.value = value ? '' : undefined
})

onBeforeMount(async () => {
  if (!criteriaComparison.value) {
    criteriaComparison.value = FilterComparison.EQ
  }
})
</script>
